import _toString from 'lodash.tostring';

export function toString(value: number | null | undefined): string {
  return _toString(value);
}
